import { Class } from './utils';
import icons from './resources/icons';
import Result from './Result';
/**
 * 
 * @class QueryResult
 * @classdesc A collection of {@link Result}s The result from a fetchData call to a searcher. Only Searchers will create instances
 * 
 */

export default Class({
  _searcher: null,
  _results: null,
  _newQueries: null,
  _allResults: null,
  initialize: function initialize(searcher) {
    this._searcher = searcher;
    this._results = [];
    this._newQueries = [];
    this._allResults = [];
    this._target = this.getTarget(this._searcher);

    if (searcher && searcher.hasOwnProperty("iconURI") && searcher.iconURI !== null && searcher.iconURI !== "" && searcher.iconURI !== undefined) {
      this.newQueryIconURI = searcher.iconURI;
      this.resultIconURI = searcher.iconURI;
    } else {
      this.newQueryIconURI = icons.result.defaultNewQueryIcon;
      this.resultIconURI = icons.result.defaultIcon;
    }
  },
  addResult: function addResult(source, type, title, description, geometry, data) {
    var result = new Result({
      source: source,
      // Safety catches if type is string (Old way of specifying type)
      type: type.id ? type.id : type,
      title: title,
      description: description ? description : null,
      geometry: geometry,
      data: data,
      "searcher": this._searcher,
      "image": this.resultIconURI
    });
    /*
    const result = {
      source,
      type,
      title,
      description,
      geometry,
      data,
      "searcher": this._searcher,
      "image": this.resultIconURI
    };
    */

    this._results.push(result);

    this._allResults.push(result);

    return result;
  },
  addResults: function addResults(results) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var result = _step.value;
        if (typeof result.target === 'undefined') result.target = this._target;

        this._results.push(result);

        this._allResults.push(result);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  },
  addNewQuery: function addNewQuery(source, type, title, description, newQuery, geometry, data) {
    var newNewQuery = new Result({
      source: source,
      // Safety catches if type is string (Old way of specifying type)
      type: type.id ? type.id : type,
      title: title,
      description: description ? description : null,
      "newquery": newQuery,
      geometry: geometry,
      data: data,
      "searcher": this._searcher,
      "image": this.newQueryIconURI
    });
    /*
    const newNewQuery = {
      source,
      type,
      title,
      description,
      "newquery": newQuery,
      geometry,
      data,
      "searcher": this._searcher,
      "image": this.newQueryIconURI
    };
    */

    this._newQueries.push(newNewQuery);

    this._allResults.push(newNewQuery);

    return newNewQuery;
  },
  addNewQueries: function addNewQueries(newQueries) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = newQueries[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var newQuery = _step2.value;

        this._newQueries.push(newQuery);

        this._allResults.push(newQuery);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  },
  getSearcher: function getSearcher() {
    return this._searcher;
  },
  getTarget: function getTarget(searcher) {
    var target = "none";
    if (typeof searcher !== 'undefined' && searcher !== null) if (searcher.title !== '') {
      target = searcher.title;
    } else {
      target = searcher.getId();
    }
    return target;
  },
  getNewQueries: function getNewQueries() {
    return this._newQueries;
  },
  getResults: function getResults() {
    return this._results;
  },
  getAllResults: function getAllResults() {
    return this._allResults;
  },
  CLASS_NAME: 'Septima.Search.QueryResult'
});